// extracted by mini-css-extract-plugin
export default {"form":"HuUxKfEvYN5TQQihJsLkxw==","submit-btn":"_30Zu0ntUG+0tAqHn4tqGlQ== btn btn--primary"};